import { createSelector } from '@ngrx/store';
import { selectMultiEditEnabled, selectMultiEditSelectedEntities } from '../product-view/product-view.selectors';
import { ProductTreeTraverseService } from '../../../core/services/productTreeTraverse.service';
import { selectSelectedEntity } from './project-data.selectors';

export interface VisualProductViewStatus {
  show3d: boolean;
  noShowReasonTextId?: string;
  hoodId?: string;
}

export const select3DViewStatus = createSelector(
  selectSelectedEntity,
  selectMultiEditEnabled,
  selectMultiEditSelectedEntities,
  (selectedEntity, multiEditEnabled, multiEditSelectedEntities): VisualProductViewStatus => {
    if (!multiEditEnabled) {
      if (!selectedEntity) {
        return {
          show3d: false,
          noShowReasonTextId: 'UI.ProductView.No3DReason.NoSelectedProduct'
        };
      }

      return {
        show3d: true,
        hoodId: ProductTreeTraverseService.findParentHoodId(selectedEntity)
      };
    }

    const parentHoodIds = new Set(multiEditSelectedEntities.map(ProductTreeTraverseService.findParentHoodId));

    if (parentHoodIds.size === 1) {
      const [id] = parentHoodIds;
      return {
        show3d: true,
        hoodId: id
      };
    }

    const reason =
      parentHoodIds.size > 1 ? 'UI.ProductView.No3DReason.MultipleSelectedHoods' : 'UI.ProductView.No3DReason.NoSelectedProduct';

    return {
      show3d: false,
      noShowReasonTextId: reason
    };
  }
);

export const selectCurrent3DViewHoodId = createSelector(select3DViewStatus, status => {
  return status.hoodId;
});
